export default __webpack_public_path__ + "images/43552cb3a94db6232182d34e27c04462.png";